import { render, staticRenderFns } from "./layout-default.vue?vue&type=template&id=b694236e&"
import script from "./layout-default.vue?vue&type=script&lang=ts&"
export * from "./layout-default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports